import { currencyFormat } from 'common/helpers/numberHelper';
import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';

const Tender = (props) => {
  const { tender, multiple, settings } = props;
  return (
    <>
      <br />
      {renderTender(tender)}
      {renderTenderAmount(tender, multiple, settings)}
    </>
  );
};

const renderTender = (tender) => {
  if (tender.tenderType !== 'Credit Card') {
    return <>{tender.tenderType}</>;
  }
  const { creditCard } = tender;
  if (creditCard.cardBrand) {
    return (
      <>
        <CreditCardDisplay creditCard={creditCard} />
      </>
    );
  }
  return <>{tender.tenderType}</>;
};

const renderTenderAmount = (tender, multiple, settings) => {
  if (!multiple) {
    return false;
  }
  return (
    <>
      <br />
      Amount: {currencyFormat(tender.amountTendered, settings)}
    </>
  );
};

export default Tender;
